import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector'; // public/locales/{lang}/translation.json
import { initReactI18next } from 'react-i18next';
import global_en from '../i18n/locales/en/translation.json'
import global_es from '../i18n/locales/es/translation.json'

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbacklng:'en',
    debug:true,
    interpolation:{
        escapeValue:false
    },
    resources:{
      en:{
        global:global_en
      },
      es:{
        global:global_es
      }
    }
  });

  export default i18n;